export const GET_ERPURL_LIST = "GET_ERPURL_LIST";
export const GET_ERPURL_LIST_SUCCESS = "GET_ERPURL_LIST_SUCCESS";
export const EDIT_ERPURL_ID = "EDIT_ERPURL_ID";
export const EDIT_ERPURL_ID_SUCCESS = "EDIT_ERPURL_ID_SUCCESS";
export const SAVE_ERPURL_MASTER = "SAVE_ERPURL_MASTER";
export const SAVE_ERPURL_MASTER_SUCCESS = "SAVE_ERPURL_MASTER_SUCCESS";
export const UPDATE_ERPURL_ID = "UPDATE_ERPURL_ID";
export const UPDATE_ERPURL_ID_SUCCESS = "UPDATE_ERPURL_ID_SUCCESS";
export const DELETE_ERPURL_ID = "DELETE_ERPURL_ID";
export const DELETE_ERPURL_ID_SUCCESS = "DELETE_ERPURL_ID_SUCCESS";
export const GET_ERPURL_DETAILS_BY_MASTER = "GET_ERPURL_DETAILS_BY_MASTER";
export const GET_ERPURL_DETAILS_BY_MASTER_SUCCESS = "GET_ERPURL_DETAILS_BY_MASTER_SUCCESS";
export const GET_ERPURL_PARTY_DROPDOWN = "GET_ERPURL_PARTY_DROPDOWN";
export const GET_ERPURL_PARTY_DROPDOWN_SUCCESS = "GET_ERPURL_PARTY_DROPDOWN_SUCCESS";
export const ERPURL_API_ERROR = "ERPURL_API_ERROR";